import { useParams, useNavigate, useSearchParams, Link, useLocation } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import ContactView from './ContactView';
import ContactModal from './ContactModal';
import { Container, Card, Tabs, Tab, Button } from 'react-bootstrap';
import { BiPencil } from "react-icons/bi";
import { BsChevronLeft } from "react-icons/bs";
const SelectedContactDetails = () => {
    const { id } = useParams(); // Get instance ID from the URL
    const location = useLocation();
    const navigate = useNavigate();
    const [selectedContactDetails, setSelectedContactDetails] = useState(null);
    const [clientDetails, setClientDetails] = useState(null);
    const [projectDetails, setProjectDetails] = useState(null);
    const [subProjects, setSubProjects] = useState(false);
    const [activeTab, setActiveTab] = useState('instanceInfo');
    const [orgDetails, setOrgDetails] = useState(null);
    const [leadDetails, setLeadDetails] = useState(null);
    const [dealDetails, setDealDetails] = useState(null);
    const [instanceDetails, setInstanceDetails] = useState(null);
    const [tenantDetails, setTenantDetails] = useState(null);

    const [showModal, setShowModal] = useState(false);
    const [selectedContact, setSelectedContact] = useState(null);

    const didFetchRef = useRef(false); // Use ref to track whether the API has been called

    // Function to fetch instance details
    const fetchSelectedContactDetails = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;

            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;

            // Make the API request to fetch contact details
            const response = await axios.get(`${backendUrl}/api/contact/${id}`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
            });

            setSelectedContactDetails(response.data.contact);

            if (response.data.client) {
                setClientDetails(response.data.client);
            }
            if (response.data.project) {
                setProjectDetails(response.data.project);
            }
            if (response.data.organisation) {
                setOrgDetails(response.data.organisation);
            }
            if (response.data.lead) {
                setLeadDetails(response.data.lead);
            }
            if (response.data.deal) {
                setDealDetails(response.data.deal);
            }

            if (response.data.contact.parent_id) {
                setSubProjects(true);
            }
            if (response.data.instance) {
                setInstanceDetails(response.data.instance);
            }
            if (response.data.tenant) {
                setTenantDetails(response.data.tenant);
            }
        } catch (error) {
            console.error('Error fetching contact details:', error);
        }
    };



    useEffect(() => {
        if (!didFetchRef.current) {
            fetchSelectedContactDetails(); // Fetch project details only once
            didFetchRef.current = true; // Set the flag to true after fetching
        }
    }, [id]);


    // Handle back button click
    const handleBackClick = () => {
        navigate(-1);
    };

    // Handle tab click to change active tab
    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    {/* Page Title */}
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0 font-size-18 d-flex align-items-center">
                                    <BsChevronLeft
                                        className='back-button1'
                                        onClick={() => navigate(-1)}
                                    />
                                    <span>Contact Details</span>
                                </h4>
                                <div className="page-title-right">
                                    <ol className="breadcrumb m-0">
                                        <li className="breadcrumb-item"><Link to={`/project/details/${id}`}>
                                            {selectedContactDetails?.name || " Contact Details"}
                                        </Link></li>
                                        <li className="breadcrumb-item active">Details</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="p-6 max-w-7xl mx-auto">
                        <>
                            <Card className="mb-2 shadow-lg rounded-3 p-2 border-0 card-bg" >
                                {/* Header Section with Name and Edit Icon */}
                                <div className="d-flex justify-content-between align-items-center">
                                    <Card.Title className="fw-bold font-size-14 text-primary">{selectedContactDetails?.name}</Card.Title>
                                    {/* <BiPencil
                                        className="text-primary hover-effect2"
                                        style={{ cursor: 'pointer', fontSize: '1.5rem' }}
                                        onClick={() => {
                                            setSelectedContact(selectedContactDetails); // Store organisation details
                                            setShowModal(true); // Open modal
                                        }} /> */}
                                </div>
                                <Card.Body className="pt-3">
                                    <div className="row">
                                        {/* Left Section */}
                                        <div className="col-md-6">
                                            <div className="mb-3">
                                                <span className="text-muted d-block card-label"><strong>phone:</strong></span>
                                                <span className=" text-muted card-value">{selectedContactDetails?.phone || '-'}</span>
                                            </div>
                                            <div className="mb-3">
                                                <span className="text-muted d-block card-label"><strong>Email:</strong></span>
                                                <span className=" text-muted card-value">{selectedContactDetails?.email || '-'}</span>
                                            </div>
                                        </div>

                                        {/* Right Section */}
                                        <div className="col-md-4">
                                            <div className="mb-3">
                                                <span className="text-muted d-block card-label"><strong>Position:</strong></span>
                                                <span className="fw-semibold text-primary card-value">{selectedContactDetails?.position || ''}</span>
                                            </div>
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                            {/* {showModal && (
                                <LeadModal
                                    showModal={showModal}
                                    handleClose={() => setShowModal(false)}
                                    leadData={selectedLead} // Pass data here
                                    editLead={editLead}
                                    fetchOrganisation={fetchOrganisation}
                                    fetchContacts={fetchContacts}
                                    contacts={contacts}
                                    organisations={organisations}
                                    leadId={id}
                                />
                            )} */}

                        </>

                        <div className="row">
                            <div className="col-xl-12 col-lg-8">
                                <div className="card">
                                    <ul className="nav nav-tabs nav-tabs-custom justify-content-start pt-2 font-size-13" role="tablist">
                                        <li className="nav-item">
                                            <a
                                                className={`nav-link ${activeTab === 'instanceInfo' ? 'active' : ''}`}
                                                onClick={() => setActiveTab('instanceInfo')}
                                                role="tab"
                                            >
                                                Instances
                                            </a>
                                        </li>
                                        <li className="nav-item">
                                            <a
                                                className={`nav-link ${activeTab === 'tenantInfo' ? 'active' : ''}`}
                                                onClick={() => setActiveTab('tenantInfo')}
                                                role="tab"
                                            >
                                                Tenants
                                            </a>
                                        </li>
                                        <li className="nav-item">
                                            <a
                                                className={`nav-link ${activeTab === 'clientInfo' ? 'active' : ''}`}
                                                onClick={() => setActiveTab('clientInfo')}
                                                role="tab"
                                            >
                                                Clients
                                            </a>
                                        </li>

                                        <li className="nav-item">
                                            <a
                                                className={`nav-link ${activeTab === 'projectInfo' ? 'active' : ''}`}
                                                onClick={() => setActiveTab('projectInfo')}
                                                role="tab"
                                            >
                                                Projects
                                            </a>
                                        </li>
                                        <li className="nav-item">
                                            <a
                                                className={`nav-link ${activeTab === 'organisationInfo' ? 'active' : ''}`}
                                                onClick={() => setActiveTab('organisationInfo')}
                                                role="tab"
                                            >
                                                Organisations
                                            </a>
                                        </li>

                                        <li className="nav-item">
                                            <a
                                                className={`nav-link ${activeTab === 'leadInfo' ? 'active' : ''}`}
                                                onClick={() => setActiveTab('leadInfo')}
                                                role="tab"
                                            >
                                                Leads
                                            </a>
                                        </li>
                                        <li className="nav-item">
                                            <a
                                                className={`nav-link ${activeTab === 'dealInfo' ? 'active' : ''}`}
                                                onClick={() => setActiveTab('dealInfo')}
                                                role="tab"
                                            >
                                                Opportunities
                                            </a>
                                        </li>
                                        <li className="nav-item">
                                            <a
                                                className={`nav-link ${activeTab === 'contactInfo' ? 'active' : ''}`}
                                                onClick={() => setActiveTab('contactInfo')}
                                                role="tab"
                                            >
                                                Contact Details
                                            </a>
                                        </li>
                                    </ul>
                                    <div className="tab-content p-4">
                                        {activeTab === 'contactInfo' && selectedContactDetails && (
                                            <div className="tab-pane active" id="contact-list" role="tabpanel">
                                                <div className="p-3">
                                                    <ContactView data={selectedContactDetails} setSelectedContactDetails={setSelectedContactDetails} />
                                                </div>
                                            </div>
                                        )}
                                        {activeTab === 'clientInfo' && (
                                            <div className="tab-pane active" id="client-list" role="tabpanel">
                                                <div className="p-3">
                                                    <br /><br />
                                                    <table className="table table-hover datatable dt-responsive nowrap view-table font-size-13" >

                                                        <thead>
                                                            <tr>
                                                                <th scope="col">#</th>

                                                                <th scope="col">Client ID</th>

                                                                <th scope="col">Name</th>
                                                                <th scope="col">Business Name</th>
                                                                <th scope="col">Email</th>
                                                                <th scope="col">Phone</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {clientDetails && clientDetails.length > 0 ? (
                                                                clientDetails.map((client, index) => (
                                                                    <tr key={index}>
                                                                        <td>{index + 1}</td>

                                                                        <td><Link to={`/contacts/client/details/${client.id}`} className="dropdown-item">{client.contact_id}</Link></td>

                                                                        <td><Link to={`/contacts/client/details/${client.id}`} className="dropdown-item">{client.name}</Link></td>
                                                                        <td>{client.business_name}</td>
                                                                        <td>{client.email}</td>
                                                                        <td>{client.mobile}</td>
                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan="4" className="text-center">No Clients</td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        )}
                                        {activeTab === 'projectInfo' && (
                                            <div className="tab-pane active" id="project-list" role="tabpanel">
                                                <div className="p-3">                                               <br /><br />
                                                    <table className="table table-hover datatable dt-responsive nowrap view-table font-size-13" >

                                                        <thead>
                                                            <tr>
                                                                <th scope="col">#</th>

                                                                <th scope="col">Project ID</th>
                                                                <th scope="col">Project Name</th>
                                                                <th scope="col">Project Code </th>
                                                                <th scope="col">Start Date</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {projectDetails && projectDetails.length > 0 ? (
                                                                projectDetails.map((project, index) => (
                                                                    <tr key={index}>
                                                                        <td>{index + 1}</td>

                                                                        <td><Link to={`/project/details/${project.id}`} className="dropdown-item">{project.project_number}</Link></td>

                                                                        <td><Link to={`/project/details/${project.id}`} className="dropdown-item">{project.name}</Link></td>
                                                                        <td>{project.code}</td>

                                                                        <td>{project.start_date}</td>
                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan="4" className="text-center">No Projects</td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        )}
                                        {activeTab === 'organisationInfo' && (
                                            <div className="tab-pane active" id="contact-list" role="tabpanel">
                                                <div className="p-3">                                                <br /><br />
                                                    <table className="table table-hover datatable dt-responsive nowrap view-table font-size-13" >

                                                        <thead>
                                                            <tr>
                                                                <th scope="col">#</th>

                                                                <th scope="col">Name</th>
                                                                <th scope="col">Employee Size</th>
                                                                <th scope="col">Sector </th>
                                                                <th scope="col"> Type</th>

                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {orgDetails && orgDetails.length > 0 ? (
                                                                orgDetails.map((org, index) => (
                                                                    <tr key={index}>
                                                                        <td>{index + 1}</td>

                                                                        <td><Link to={`/organisation/details/${org.id}`} className="dropdown-item">{org.name}</Link></td>

                                                                        <td><Link to={`/organisation/details/${org.id}`} className="dropdown-item">{org.employee_size}</Link></td>
                                                                        <td>{org.industry?.name}</td>

                                                                        <td>{org.org_type}</td>

                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan="4" className="text-center">No Projects</td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        )}
                                        {activeTab === 'leadInfo' && (
                                            <div className="tab-pane active" id="contact-list" role="tabpanel">
                                                <div className="p-3">                                               <br /><br />
                                                    <table className="table table-hover datatable dt-responsive nowrap view-table font-size-13" >

                                                        <thead>
                                                            <tr>
                                                                <th scope="col">#</th>

                                                                <th scope="col">Organisation</th>
                                                                <th scope="col">Lead Source</th>
                                                                <th scope="col">Status </th>
                                                                <th scope="col">Notes</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {leadDetails && leadDetails.length > 0 ? (
                                                                leadDetails.map((lead, index) => (
                                                                    <tr key={index}>
                                                                        <td>{index + 1}</td>

                                                                        <td><Link to={`/lead/details/${lead.id}`} className="dropdown-item">{lead.organisation?.name}</Link></td>

                                                                        <td><Link to={`/lead/details/${lead.id}`} className="dropdown-item">{lead.lead_source}</Link></td>
                                                                        <td>{lead.status}</td>

                                                                        <td>{lead.notes}</td>
                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan="4" className="text-center">No Projects</td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        )}
                                        {activeTab === 'dealInfo' && (
                                            <div className="tab-pane active" id="contact-list" role="tabpanel">
                                                <div className="p-3">                                               <br /><br />
                                                    <table className="table table-hover datatable dt-responsive nowrap view-table font-size-13" >

                                                        <thead>
                                                            <tr>
                                                                <th scope="col">#</th>

                                                                <th scope="col">Name</th>
                                                                <th scope="col">Value</th>
                                                                <th scope="col">Closed Date </th>
                                                                <th scope="col">Stage</th>
                                                                <th scope="col">Organisation</th>
                                                                <th scope="col">Probability</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {dealDetails && dealDetails.length > 0 ? (
                                                                dealDetails.map((deal, index) => (
                                                                    <tr key={index}>
                                                                        <td>{index + 1}</td>

                                                                        <td><Link to={`/deal/details/${deal.id}`} className="dropdown-item">{deal.name}</Link></td>

                                                                        <td><Link to={`/deal/details/${deal.id}`} className="dropdown-item">{deal.value}</Link></td>
                                                                        <td>{deal.closed_date}</td>

                                                                        <td>{deal.stage}</td>
                                                                        <td>{deal.organisation?.name}</td>
                                                                        <td>{deal.probability}</td>

                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan="4" className="text-center">No Projects</td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        )}
                                        {activeTab === 'tenantInfo' && (
                                            <div className="tab-pane active" id="contact-list" role="tabpanel">
                                                <div className="p-3">                                                <br /><br />
                                                    <table className="table table-hover datatable dt-responsive nowrap view-table font-size-13" >

                                                        <thead>
                                                            <tr>
                                                                <th scope="col">#</th>
                                                                <th scope="col"> Name</th>
                                                                <th scope="col">Tenant Id</th>
                                                                <th scope="col">Contract Type </th>
                                                                <th scope="col">License Type</th>
                                                                <th scope="col">Status</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {tenantDetails && tenantDetails.length > 0 ? (
                                                                tenantDetails.map((tenant, index) => (
                                                                    <tr key={index}>
                                                                        <td>{index + 1}</td>
                                                                        <td><Link to={`/tenant/details/${tenant.id}`} className="dropdown-item">{tenant.name}</Link></td>

                                                                        <td><Link to={`/tenant/details/${tenant.id}`} className="dropdown-item">{tenant.tenant_id}</Link></td>
                                                                        <td>{tenant.contract_type}</td>

                                                                        <td>{tenant.license_type}</td>
                                                                        <td>{tenant.account_status}</td>

                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan="4" className="text-center">No Projects</td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        )}
                                        {activeTab === 'instanceInfo' && (
                                            <div className="tab-pane active" id="contact-list" role="tabpanel">
                                                <div className="p-3">                                               <br /><br />
                                                    <table className="table table-hover datatable dt-responsive nowrap view-table font-size-13" >

                                                        <thead>
                                                            <tr>
                                                                <th scope="col">#</th>

                                                                <th scope="col">Setup Name</th>
                                                                <th scope="col">Setup Id</th>
                                                                <th scope="col">Setup Mode </th>
                                                                <th scope="col">Setup Type</th>
                                                                <th scope="col">Status</th>
                                                                <th scope="col">Contact Type</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {instanceDetails && instanceDetails.length > 0 ? (
                                                                instanceDetails.map((instance, index) => (
                                                                    <tr key={index}>
                                                                        <td>{index + 1}</td>

                                                                        <td><Link to={`/instance/details/${instance.id}`} className="dropdown-item">{instance.setup_name}</Link></td>

                                                                        <td><Link to={`/instance/details/${instance.id}`} className="dropdown-item">{instance.setup_id}</Link></td>
                                                                        <td>{instance.setup_mode}</td>

                                                                        <td>{instance.setup_type}</td>
                                                                        <td>{instance.active_status}</td>
                                                                        <td>{instance.contact_type}</td>

                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan="4" className="text-center">No Projects</td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SelectedContactDetails;
